export enum tabs {
    PRIVATE = 'PRIVATE',
    BUSINESS = 'BUSINESS',
}
